import React from 'react'
import { Field } from 'redux-form'
import { Radio, RadioGroup } from 'loankeeper-common/components'

class RadioField extends React.Component {
  handleRadioChange = (value) => {
    const { input, customOnChange } = this.props

    input.onChange(value)

    if (customOnChange) customOnChange(value)
  }

  render() {
    const { input, className, disabled, selectedValue, options } = this.props

    return (
      <RadioGroup
        className={className}
        name={input.name}
        selectedValue={selectedValue}
        disabled={disabled}
        onChange={this.handleRadioChange}
      >
        {options.map((option) => (
          <Radio key={option.value} {...option} />
        ))}
      </RadioGroup>
    )
  }
}

const DecoratedField = (props) => <Field {...props} component={RadioField} />

export default DecoratedField
